import {createRoot, hydrateRoot} from 'react-dom/client';
import SingleTourTemplate from '../pages/SingleTourTemplate/SingleTourTemplate'
import "../index.css";
import "../pages/SingleTourTemplate/SingleTourTemplate.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SingleTourTemplate {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SingleTourTemplate {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SingleTourTemplateVC = {mount, hydrate, unmount}